// Behaviour shared by every "spot picker" screen (put-away step 1 + the "Was liegt hier?" lookup):
//  - segmented Scannen/Manuell control (+ any [data-tab] link, e.g. the scan pane's "Manuell wählen")
//  - client-side Platz-Nr. filter with a live "N Treffer" count
// Bound to [data-spot-picker]; each screen carries that attr alongside its own hook attribute.
// `up` is a global in this app (like every other compiler) — do not import it.

up.compiler('[data-spot-picker]', (root) => {
  const activateTab = (name) => {
    root.querySelectorAll('.spot-picker__tab').forEach((t) => t.classList.toggle('is-active', t.dataset.tab === name))
    root.querySelectorAll('.spot-picker__pane').forEach((p) => p.classList.toggle('is-active', p.dataset.pane === name))
  }

  up.on(root, 'click', '[data-tab]', (event, el) => {
    event.preventDefault()
    activateTab(el.dataset.tab)
  })

  // Delegated so it survives Platz-grid fragment swaps (#platz-grid / #lookup-platze).
  up.on(root, 'input', '[data-platz-filter]', (event, input) => {
    const q = input.value.trim().toLowerCase()
    let hits = 0
    root.querySelectorAll('.platz-btn').forEach((b) => {
      const match = q === '' || (b.dataset.spotNumber || '').includes(q)
      b.hidden = !match
      if (match) hits += 1
    })
    const range = root.querySelector('[data-platz-range]')
    const count = root.querySelector('[data-platz-count]')
    if (range) range.hidden = q !== ''
    if (count) {
      count.hidden = q === ''
      count.textContent = q === '' ? '' : `${hits} Treffer`
    }
  })
})
